var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.7205 3.01689C22.9992 3.01689 23.2757 3.01689 23.5502 3.01689C20.8381 5.53694 19.0949 8.92767 18.6235 12.5997C18.152 16.2717 18.9823 19.9928 20.9698 23.1162C22.9574 26.2396 25.9766 28.5677 29.5027 29.696C33.0287 30.8242 36.8386 30.6812 40.2702 29.2918C38.9502 32.4679 36.7927 35.2262 34.028 37.2723C31.2633 39.3185 27.995 40.5757 24.5718 40.91C21.1485 41.2443 17.6987 40.6431 14.5904 39.1705C11.482 37.6979 8.83175 35.4091 6.9222 32.5484C5.01265 29.6876 3.91548 26.3621 3.74772 22.9267C3.57995 19.4913 4.3479 16.0747 5.96963 13.0415C7.59136 10.0083 10.0061 7.47223 12.9561 5.70377C15.9062 3.93531 19.281 3.00083 22.7205 3V3.01689Z",
    fill: "#F2F2F2"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNight);
export default __webpack_public_path__ + "static/media/night.1ec33a30e337d9e34c8264fa5a0fab48.svg";
export { ForwardRef as ReactComponent };